import qrTaobaoImg from "@images/qr-shop-taobao.jpg"
import qrTianmaoImg from "@images/qr-shop-tianmao.jpg"
import qrXiaohongshuImg from "@images/qr-shop-xiaohongshu.png"
import qrWeixinImg from "@images/qr-weixin.jpg"

export const TAOBAO = { name: "淘宝店铺", icon: "gi_i_taobao", qr: qrTaobaoImg }
export const TIANMAO = {
  name: "天猫旗舰店",
  icon: "gi_i_tianmao",
  qr: qrTianmaoImg,
}
export const XIAOHONGSHU = {
  name: "小红书店铺",
  icon: "gi_i_xiaohongshu",
  qr: qrXiaohongshuImg,
}
export const GCORESAPP = {
  name: "机核App商城",
  icon: "gi_i_gcores",
  link: "https://www.gcores.com/app",
}
export const WEIXIN = {
  icon: "gi_i_weixin",
  qr: qrWeixinImg,
}
export const WEIBO = {
  icon: "gi_i_weibo",
  link: "https://weibo.com/n/吉考斯工业",
}
export const BILIBILI = {
  icon: "gi_i_bilibili",
  link: "https://space.bilibili.com/108865101?spm_id_from=333.337.0.0",
}
export const INS = {
  icon: "gi_i_ins",
  link: "https://www.instagram.com/gcores_industries/",
}

export const CHANNELS = [TAOBAO, TIANMAO, XIAOHONGSHU, GCORESAPP]
export const MEDIA_LIST = [XIAOHONGSHU, WEIXIN, WEIBO, BILIBILI, INS, GCORESAPP]
